import React from 'react';

import { Box } from '@material-ui/core';
import cx from 'classnames';

import useStyles from './styles';

interface CardProps {
  wrapperClass?: string;
}

const Card: React.FC<CardProps> = ({ children, wrapperClass = '' }) => {
  const classes = useStyles();

  return <Box className={cx(classes.wrapper, wrapperClass)}>{children}</Box>;
};

export default Card;
